import { RootState } from '../reducers';

export const getDynamicTabsFromStore = (state: RootState): DynamicTabsState => state.DynamicTabs;
export const getDynamicTabListFromStore = (state: RootState): TabList => state.DynamicTabs.tabList;
export const getActiveTab = (state: RootState): DynamicTabsState['activeTab'] => state.DynamicTabs.activeTab;
export const getTabData =
  (state: RootState, tabId: DynamicTabComponent['id']) => state.DynamicTabs.tabList.find(tab => tab.id === tabId) as DynamicTabWithForm<any> | DynamicTabWithTable<any>;
export const getTabIndex =
  (state: RootState, tabId: DynamicTabComponent['id']) => getDynamicTabListFromStore(state).findIndex(tab => tab.id === tabId) as number;